// extracted by mini-css-extract-plugin
export default {"card":"ImportantNowCard_card__L763N","linkBox":"ImportantNowCard_linkBox__CB0H4","link":"ImportantNowCard_link__ZZxi2"};